import { toIsoTimestamp, toMillis } from './time';

/**
 * Apply a top-level parent row patch for an incoming thread reply.
 * Increments parent threadReplyCount and updates threadLastReplyAt.
 *
 * @param {Array<object>} messages
 * @param {object} replyMessage
 * @returns {Array<object>}
 */
export function applyThreadParentPatch(messages, replyMessage) {
  if (!Array.isArray(messages) || !replyMessage?.threadParentId) return messages;

  const parentIndex = messages.findIndex((message) => message.id === replyMessage.threadParentId);
  if (parentIndex < 0) return messages;

  const parent = messages[parentIndex];
  const parentCount = Number.isFinite(parent?.threadReplyCount) ? parent.threadReplyCount : 0;
  const replyTimestamp = toIsoTimestamp(replyMessage.createdAt || replyMessage.timestamp);

  const currentLastReplyMillis = toMillis(parent?.threadLastReplyAt);
  const incomingReplyMillis = toMillis(replyTimestamp);
  const shouldUpdateLastReply = (
    incomingReplyMillis > 0
    && (!currentLastReplyMillis || incomingReplyMillis >= currentLastReplyMillis)
  );

  const nextParent = {
    ...parent,
    threadReplyCount: parentCount + 1,
    threadLastReplyAt: shouldUpdateLastReply
      ? replyTimestamp
      : (parent.threadLastReplyAt || null)
  };

  const next = [...messages];
  next[parentIndex] = nextParent;
  return next;
}
